<template>
  <b-row class="justify-content-center py-5">
    <b-col sm="10" md="8" lg="6">
      <b-card no-body class="mx-4">
        <b-card-body class="p-4">
          <h1>Reset Password</h1>
          <p class="text-muted">Please setup your new password</p>

          <b-form @submit.prevent="handleSubmit">
            <NanInput
              v-model="token"
              :validation="$v.token"
              :hidden="isPrefilled"
              prependIcon="icon-key"
              placeholder="Token"
              aria-label="Token"
              class="mb-3"
            />

            <NanInput
              v-model="pass"
              :validation="$v.pass"
              type="password"
              prependIcon="icon-lock"
              placeholder="New Password"
              aria-label="New Password"
              class="mb-3"
            />

            <NanInput
              v-model="repeat"
              :validation="$v.repeat"
              type="password"
              prependIcon="icon-lock"
              placeholder="Repeat Password"
              aria-label="Repeat Password"
              class="mb-4"
            />

            <b-button
              :class="{ disabled: $v.$invalid }"
              variant="primary"
              type="submit"
              block
              >Reset Password</b-button
            >
          </b-form>
        </b-card-body>
        <b-card-footer class="p-4">
          <span class="text-muted">Already have an account?&nbsp;</span>
          <router-link :to="{ name: 'Login' }">Login</router-link>
        </b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  maxLength,
  minLength,
  required,
  sameAs
} from "vuelidate/lib/validators";
import { password } from "@/helpers/validators";

export default {
  mixins: [validationMixin],

  data: () => ({
    token: "",
    pass: "",
    repeat: "",
    isPrefilled: false
  }),

  created() {
    if (this.$route.query.token) {
      this.token = this.$route.query.token || "";
      this.isPrefilled = true;
    }
  },

  methods: {
    async handleSubmit() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      const { token, pass } = this;

      await this.$store.dispatch("user/resetPassword", {
        token,
        pass
      });

      if (this.$store.state.user.id) {
        this.$router.push("/");
      }
    }
  },

  validations: {
    token: { required },
    pass: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(250),
      password
    },
    repeat: { required, matches: sameAs("pass") }
  }
};
</script>
